Vue.component( 'google-chart', {

    props: {
        type: String,
        table: Array,
        options: Object,
    },

    data() {
        return {
            ready: false,
            chart: null,
        };
    },

    template: `<div class="google-chart" ref="container"></div>`,

    watch: {
        table: function() {
            this.render();
        },
    },

    methods: {

        init() {
            this.ready = true;
            this.chart = new google.visualization[ this.type ]( this.$refs[ 'container' ] );
            this.render();
        },

        render() {
            if ( !this.ready ) return;

            let dataTable = google.visualization.arrayToDataTable( this.table );

            this.chart.draw( dataTable, this.options );
        },

    },

    mounted() {
        window.GoogleChartsLoadedPromise.then( this.init );
    },

} );
